import axios from "../http-client/axios";
import { ANTHRAX_URL } from "../urls/base-urls";
//export const ANTHRAX_URL = 'http://localhost:8287';

export async function uploadFiles({ files }) {
  if (!files) return [];
  return await Promise.all(
    files.map(async (file) => {
      var formData = new FormData();
      formData.append("file", file);

      const resp = await axios.post(`${ANTHRAX_URL}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return resp.data;
    })
  );
}

export async function getSignedUrl(path) {
  const resp = await axios({
    url: `${ANTHRAX_URL}/generate-signed-url?filePath=${path}`,
    method: "get",
    headers: { "content-type": "application/json" }
  });

  return resp.data;
}

